import React, { createContext, useState, useContext, ReactNode } from "react";
import { FolderList } from "./modal";

// Define the context type
interface FileRepositoryContextType {
  folderList: FolderList[] | null;
  setFolderList: (folder: FolderList[] | null) => void;

  selectedFolder: FolderList | null;
  setSelectedFolder: (folder: FolderList | null) => void;

  refreshFolderList: boolean;
  setRefreshFolderList: (refresh: boolean) => void;

  openedListItems: number[];
  setOpenedListItems: (ids: number[]) => void;
}

// Create the context
const FileRepositoryContext = createContext<
  FileRepositoryContextType | undefined
>(undefined);

// Define the provider component
interface FileRepositoryProviderProps {
  children: ReactNode;
}

export const FileRepositoryProvider: React.FC<FileRepositoryProviderProps> = ({
  children,
}) => {
  const [folderList, setFolderList] = useState<FolderList[] | null>([]);
  const [selectedFolder, setSelectedFolder] = useState<FolderList | null>(null);
  const [refreshFolderList, setRefreshFolderList] = useState<boolean>(false);
  const [openedListItems, setOpenedListItems] = useState<number[]>([]);

  return (
    <FileRepositoryContext.Provider
      value={{
        folderList,
        setFolderList,
        selectedFolder,
        setSelectedFolder,
        refreshFolderList,
        setRefreshFolderList,
        openedListItems,
        setOpenedListItems,
      }}
    >
      {children}
    </FileRepositoryContext.Provider>
  );
};

// Create a custom hook to use the context
export const useFileRepository = (): FileRepositoryContextType => {
  const context = useContext(FileRepositoryContext);
  if (!context) {
    throw new Error(
      "useFileRepository must be used within a FileRepositoryProvider"
    );
  }
  return context;
};
